import React from 'react'
import clsx from 'clsx'
import { Grid } from '@mui/material'

import { useStyles } from './styles'

const Indicators = ({ cantItems, current, handleGoto }) => {
  const classes = useStyles()
  const items = [...Array(cantItems).keys()]

  return (
    <Grid
      container
      spacing={4}
      className={classes.indicatorsWrapper}
      justifyContent='flex-end'
      alignItems='flex-end'
    >
      {items.map((item) => (
        <div      
          key={item}    
          className={clsx(classes.item, {
            [classes.active]: (item + 1 === current),
          })}
          onClick={() => handleGoto(item + 1)}
        />
      ))}
    </Grid>
  )
}

export default Indicators
